import React, { useState } from "react";
import Text from "@streeteasy/design-system/deprecated/Text";
import PropTypes from "prop-types";

import * as S from "./styled";

const PhoneNumberToggle = ({ children, onClick }) => {
  const [show, showPhoneNumber] = useState(false);
  const handleSpanClick = event => {
    event.stopPropagation();
    event.preventDefault();
    if (onClick) {
      onClick();
    }
    showPhoneNumber(true);
  };

  return (
    <Text as="div" type="sm">
      {show ? (
        children
      ) : (
        <S.PhoneSpan onClick={handleSpanClick}>Show phone number</S.PhoneSpan>
      )}
    </Text>
  );
};

PhoneNumberToggle.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func
};

PhoneNumberToggle.defaultProps = {
  onClick: null
};

export default PhoneNumberToggle;
